<template>
  <div class="content-wrapper" v-cloak>
    <!--        搜索区域-->
    <el-form :inline="true" :model="searchArea" class="formInline" label-width="90px">
      <el-row :gutter="80">
        <el-col :span="6">
          <el-form-item label="名称：">
            <el-input v-model="searchArea.name" size="small" placeholder="请输入名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item style="width: 100% !important">
            <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
            <el-button size="small" @click="reset">重置</el-button>
            <el-button style="margin-left: 40px" type="primary" size="small" icon="el-icon-plus" v-if="
              permissionsList.findIndex(
                (info) => info.menuTitle === '新增知识小课堂'
              ) != -1
            " @click="fileControl('add')">新增
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--        表格区域-->
    <div class="table roleTable">
      <el-table :header-cell-style="{ background: 'rgb(250,250,250)' }" v-loading="loading" :data="tableData" stripe
        style="width: 100%">
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center" min-width="80">
        </el-table-column>
        <el-table-column prop="videoNumber" label="视频号Id" align="center" min-width="80">
        </el-table-column>
        <el-table-column prop="videoFeedid" label="视频feedId" align="center" min-width="80">
        </el-table-column>
        <el-table-column prop="attachmentUrl" label="附件URL" align="center" min-width="120">
          <template slot-scope="scope">
            <a :href="scope.row.attachmentUrl" target="_blank">{{
              scope.row.attachmentUrl
            }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="createdBy" label="创建人" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" align="center" min-width="100">
          <template slot-scope="scope" v-if="scope.row.createdTime">
            {{ $moment(scope.row.createdTime).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="100">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" round plain v-if="
              permissionsList.findIndex(
                (info) => info.menuTitle === '编辑知识小课堂'
              ) != -1
            " @click="fileControl('edit', scope.row)">编辑
            </el-button>
            <el-button type="danger" size="mini" round plain v-if="
              permissionsList.findIndex(
                (info) => info.menuTitle === '删除知识小课堂'
              ) != -1
            " @click="removeById(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--        分页区域-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchArea.current" :page-sizes="[5, 10, 15, 20]" :page-size="searchArea.size" background
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="fileTitle" :visible.sync="fileVisible" :close-on-click-modal="false" width="550px"
      :before-close="fileHandleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="名称：" prop="name">
          <el-input size="small" v-model="ruleForm.name"></el-input> </el-form-item><el-form-item label="视频号Id："
          prop="videoNumber">
          <el-input size="small" v-model="ruleForm.videoNumber"></el-input>
        </el-form-item>
        <el-form-item label="视频feedId：" prop="videoFeedid">
          <el-input size="small" v-model="ruleForm.videoFeedid"></el-input>
        </el-form-item>
        <el-form-item label="附件URL：" prop="attachmentUrl">
          <el-input size="small" v-model="ruleForm.attachmentUrl"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fileCancel('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="fileSure('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  knowledgeCornerDelete,
  knowledgeCornerPage,
  knowledgeCornerSave,
  knowledgeCornerUpdate,
} from "../../tools/equipment/file";
export default {
  name: "equipTest",
  data() {
    return {
      //查询数据
      searchArea: {
        //文件名称
        name: "",
        //表格宽度
        size: 5,
        //当前多少页
        current: 1,
      },
      ruleForm: {
        name: "",
        videoNumber: "",
        videoFeedid: "",
        attachmentUrl: "",
        remark: "",
      },
      //表格数据
      tableData: [],
      //表格数据总数
      total: 0,
      //表格loading
      loading: false,
      //新增/编辑知识小课堂 数据规则
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        videoNumber: [
          { required: true, message: "请输入视频号ID", trigger: "blur" },
        ],
        videoFeedid: [
          { required: true, message: "请输入视频feedid", trigger: "blur" },
        ],
        attachmentUrl: [
          { required: true, message: "请输入附件URL", trigger: "change" },
        ],
      },
      fileVisible: false,
      fileTitle: "",
      canRun: false,
    };
  },
  created() {
    this.$store.state.nowName = "知识小课堂管理";
    this.permissionsList = this.$store.state.permissionsList;
    this.getTableData();
  },
  methods: {
    removeById(row) {
      console.log(row);
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          knowledgeCornerDelete(row.id).then((res) => {
            if (res.data.msg != "success") {
              this.$message.error(res.data.msg);
            } else {
              this.test = false;
              this.onSubmit();
              this.$message.success("删除成功！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //新增/编辑设备弹窗确定
    fileSure(formName) {
      //节流
      //没有创建上来就为假，偷懒了不想每个都创建
      if (this.canRun) {
        return;
      }
      //变成真下一次点就会return
      this.canRun = true;
      //1秒钟后变成假
      setTimeout(() => {
        this.canRun = false;
      }, 4000);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.fileTitle === "新增知识小课堂") {
            knowledgeCornerSave({
              name: this.ruleForm.name,
              videoNumber: this.ruleForm.videoNumber,
              videoFeedid: this.ruleForm.videoFeedid,
              attachmentUrl: this.ruleForm.attachmentUrl,
              remark: this.ruleForm.remark,
            }).then((res) => {
              if (res.data.msg != "success") {
                this.$message.error(res.data.msg);
              } else {
                this.$message({
                  message: "操作成功!",
                  type: "success",
                });
                this.loading = true;
                this.getTableData();
                this.clear();
                this.fileVisible = false;
              }
            });
          } else {
            knowledgeCornerUpdate({
              id: this.ruleForm.id,
              name: this.ruleForm.name,
              videoNumber: this.ruleForm.videoNumber,
              videoFeedid: this.ruleForm.videoFeedid,
              attachmentUrl: this.ruleForm.attachmentUrl,
              remark: this.ruleForm.remark,
            }).then((res) => {
              if (res.data.msg != "success") {
                this.$message.error(res.data.msg);
              } else {
                this.$message({
                  message: "操作成功!",
                  type: "success",
                });
                this.loading = true;
                this.getTableData();
                this.clear();
                this.fileVisible = false;
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //新增/编辑
    fileControl(type, row) {
      this.fileVisible = true;
      if (type === "add") {
        this.fileTitle = "新增知识小课堂";
      } else {
        this.fileTitle = "编辑知识小课堂";
        this.ruleForm.name = row.name;
        this.ruleForm.videoNumber = row.videoNumber;
        this.ruleForm.videoFeedid = row.videoFeedid;
        this.ruleForm.attachmentUrl = row.attachmentUrl;
        this.ruleForm.remark = row.remark;
        this.ruleForm.id = row.id;
      }
    },
    //新增/编辑角色弹窗右上角关闭
    fileHandleClose(done) {
      this.clear();
      done();
    },
    //清空新增/编辑角色弹窗数据
    clear() {
      this.ruleForm.name = "";
      this.ruleForm.videoNumber = "";
      this.ruleForm.videoFeedid = "";
      this.ruleForm.attachmentUrl = "";
      this.ruleForm.remark = "";
      setTimeout(() => {
        this.$refs["ruleForm"].clearValidate();
      }, 100);
    },
    //新增/编辑角色弹窗取消
    fileCancel() {
      this.clear();
      setTimeout(() => {
        this.fileVisible = false;
      }, 10);
    },
    //查询
    onSubmit() {
      this.loading = true;
      this.searchArea.current = 1;
      this.getTableData();
    },
    //重置查询参数
    reset() {
      this.searchArea.name = "";
    },
    //获取表格数据
    getTableData() {
      let data = { ...this.searchArea };
      knowledgeCornerPage(data).then((res) => {
        if (res.data.msg != "success") {
          this.$message.error(res.data.msg);
        } else {
          this.tableData = [];
          if (res.data.data != null) {
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
            this.loading = false;
          } else {
            this.tableData = [];
            this.total = 0;
            this.loading = false;
          }
        }
      });
    },
    //表格每页展示多少设置
    handleSizeChange(val) {
      this.searchArea.size = val;
      this.searchArea.current = 1;
      this.loading = true;
      this.getTableData();
    },
    //跳转页码  以及页码点击
    handleCurrentChange(val) {
      this.searchArea.current = val;
      this.loading = true;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
/*搜素区域距离底部距离*/
.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}

/*设置form表单子元素宽度*/
.content-wrapper>>>.el-form--inline .el-form-item__content {
  width: 75% !important;
}

/*设置弹出框内select宽度为100%*/
.content-wrapper>>>.el-select {
  width: 100%;
}

/*表格class*/
.roleTable {
  /*height: 70%;*/
}
</style>
